module.exports = __webpack_public_path__ + "img/amenidades1.c42c505b.png";